<template>
  <div class="row" v-if="showFornecExt">
    <div class="col-12">
      <div class="row col-12">
        <div class="col-12 row mb-2">
          <h5 class="col-12 row col-sm-3 ">
            {{ $t('Filtre as OS Preventivas') }}
          </h5>
        </div>
        <div class="col-md-2 col-sm-6 col-12 d-none">
          <button class="alert alert-danger text-capitalize cardIndicador" style="background-image: linear-gradient(45deg, rgb(72 70 70), rgb(149 148 148)) !important;">OS Preventiva</button>
        </div>
        <div class="col-sm-6 col-12">
          <button @click="showModalVencidas = true" class="alert alert-danger text-capitalize cardIndicador" style="background-image: linear-gradient(45deg, #531218, #dc3646) !important; align-items: center;"> <span class="badge mr-2 badge-warning">{{ totalPlacasVencidas }}</span> {{ $t('Preventivas Vencidas') }}</button>
        </div>
        <div class="col-sm-6 col-12">
          <button @click="showModalaVencer = true" class="alert alert-danger text-capitalize cardIndicador" style="background-image: linear-gradient(45deg, rgb(100 78 12), rgb(255 193 8)) !important;"> <span class="badge mr-2 badge-warning">{{ totalPlacasAVencer }}</span> {{ $t('Preventivas à Vencer') }}</button>
        </div>

        <div class="col-12">
          <Hr />
        </div>

        <div class="col-sm-6 col-12">
          <button @click="exibirModalCarrocerias('V')" class="alert alert-danger text-capitalize cardIndicador" style="background-image: linear-gradient(45deg, rgb(20, 62, 78), rgb(41, 133, 167)) !important; align-items: center;"> <span class="badge mr-2 badge-warning">{{ totalplacasVencidasCarrocerias }}</span> {{ $t('Carrocerias Vencidas') }}</button>
        </div>
        <div class="col-sm-6 col-12">
          <button @click="exibirModalCarrocerias('A')" class="alert alert-danger text-capitalize cardIndicador" style="background-image: linear-gradient(45deg, rgb(20, 62, 78), rgb(41, 133, 167)) !important;"> <span class="badge mr-2 badge-warning">{{ totalCarroceriasAVencer }}</span> {{ $t('Carrocerias à Vencer') }}</button>
        </div>
        <!-- 
        <div class="col-sm-8 col-12">
          <button style="background: linear-gradient(45deg, #12570d, #1d9c14)!important;" class="col-12 col-sm-2 btnLimparFiltroVerde" @click="refreshPage()"><i class="fa fa-undo"></i> {{ $t('Atualizar') }}</button>
        </div> -->

      </div>
    </div>
    <modal-os-vencidas @showModalVencidas="showModalVencidas = false" @refresh="applyFilters" v-if="showModalVencidas"></modal-os-vencidas>
    <modal-os-a-vencer @showModalaVencer="showModalaVencer = false" @refresh="applyFilters" v-if="showModalaVencer"></modal-os-a-vencer>
    <modal-carrocerias @showModalCarrocerias="showModalCarrocerias = false" @refresh="applyFilters" :tipoPreventiva="valorModalCarrocerias" :stPreventiva="stPreventiva" v-if="showModalCarrocerias"></modal-carrocerias>
  </div>
</template>

<script>
import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
import ModalOsVencidas from './Modais/ModalOsVencidas.vue'
import ModalOsAVencer from './Modais/ModalOsAVencer.vue'
import ModalCarrocerias from './Modais/ModalCarrocerias.vue'

momentDurationFormatSetup(moment)

export default {
  data() {
    return {
      items: [
        {
          ds_criticidade: 'IMEDIATA'.toLowerCase(),
          tempo_medio: '2d 1h 25min'
        },
        {
          ds_criticidade: '24 HORAS'.toLowerCase(),
          tempo_medio: '2d 1h 25min'
        },
        {
          ds_criticidade: '48 HORAS'.toLowerCase(),
          tempo_medio: '2d 1h 25min'
        },
        { ds_criticidade: '30 DIAS'.toLowerCase(), tempo_medio: '2d 1h 25min' }
      ],
      showModalVencidas: false,
      showModalaVencer: false,
      showFornecExt: true,
      showModalCarrocerias: false,
      valorModalCarrocerias: '',
      stPreventiva: ''
    }
  },

  components: {
    ModalOsVencidas,
    ModalOsAVencer,
    ModalCarrocerias
  },

  created(){
    this.$store.dispatch('osItem/placasAVencer', { stPreventiva: 'V' })
    this.$store.dispatch('osItem/placasAVencer', { stPreventiva: 'A' })

    this.$store.dispatch('osItem/carroceriasPreventivas', { stPreventivaCarroceria: "A" })
    this.$store.dispatch('osItem/carroceriasPreventivas', { stPreventivaCarroceria: "V" })

  },

  mounted() {
    this.$store.dispatch('os/fetchMediaLiberacao', { filial: this.$root.filial.nr_sequencial })

    const filial = this.$store.getters['filial/filial']
    

  if(filial.fornecExt == "S"){
    this.showFornecExt = false
  }
  },

  computed: {
    totalPlacasVencidas(){
      const total = this.$store.getters['osItem/totalPlacasVencidas']

      return total
    },
    
    totalplacasVencidasCarrocerias(){
      return this.$store.getters['osItem/setTotalCarroceriasVencidas']
    },

    totalCarroceriasAVencer(){
      return this.$store.getters['osItem/setTotalCarroceriasAVencer']
    },

    totalPlacasAVencer(){
      const total = this.$store.getters['osItem/totalplacasAVencer']

      return total
    },
    filtros() {
      return this.$store.getters['os/filters']
    },

    internalFilters() {
      return { ...this.filtros }
    },
    mediaLiberacao() {
      const media = this.$store.getters['os/mediaLiberacao']

      if (!media) return null

      const mappedMedia = media.map(item => {
        item.tempoFormatado = this.getTempoFormatado(item)

        return item
      })

      return mappedMedia
    }
  },

  methods: {
    exibirModalCarrocerias(value){
      this.valorModalCarrocerias = value
      this.showModalCarrocerias = true
    },

    refreshPage(){
      location.reload()
    },
    applyFilters(nr_nivel) {

      this.internalFilters.nr_nivel = nr_nivel

      let filters = { ...this.internalFilters }

      this.$store.commit('os/setFilters', { filters: filters })
      this.updateFilters()
    },
    updateFilters (newFilters) {
      this.$store.dispatch('os/reset')
      this.fetchItemsFromApi()
    },
    fetchItemsFromApi () {
      this.$store.dispatch('os/fetchFromApi')
    },
    indicadorBg(index) {
      switch (parseInt(index)) {
        case 0:
          return 'background-image: linear-gradient(45deg, #531218, #dc3646) !important;'
        case 1:
          return 'background-image: linear-gradient(45deg, #763c0a, #fd7f15) !important;'
        case 2:
          return 'background-image: linear-gradient(45deg, rgb(100 78 12), rgb(255 193 8)) !important;'
        case 3:
          return 'background-image: linear-gradient(45deg, #053a72, #007bff) !important;'
        default:
          return 'background-image: linear-gradient(45deg, rgb(128 128 128), rgb(202 202 202)) !important;'
      }
    },
    getTempoFormatado(media) {
      if (!media.ordem_servico.length) return null

      return moment.duration(parseInt(media.ordem_servico[0].media_horas_liberacao), 'seconds')
        .format('d[d] h[h]mm[m]', {
          userLocale: 'pt-BR'
        })
    }
  }
}
</script>
<style scoped>

.cardIndicador{
  color: #fff!important;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  border-radius: 25px; 
  text-align: center;
  border: none;
}
.btnLimparFiltro{
  background: transparent;
  border: 1px solid #c9c9c9;
  margin-left: 13px;
}
.col-md-2 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 16.66667%;
    flex: 0 0 24.66667%;
    max-width: 24.66667%;
}
</style>